/**
 * @GENERATED from Figma node 693:15934
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const MsOneDriveBright = function (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) {
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill={`url(#${_id})`}
        d="M6.383 18.75a5.42 5.42 0 0 1-4.177-1.947l11.198-4.699 8.708 4.903c-.767 1.001-1.926 1.743-3.237 1.737-1.977.006-9.582.006-12.492.006"
      />
      <path
        fill={`url(#${_id2})`}
        d="m18.585 10.029-5.18 2.075 8.707 4.903A4.28 4.28 0 0 0 23 14.396c0-2.394-1.972-4.336-4.412-4.354q0-.007-.003-.013"
      />
      <path
        fill={`url(#${_id3})`}
        d="m5.858 8.233 7.547 3.871 5.18-2.075C17.849 7.139 15.18 5 12.002 5a6.81 6.81 0 0 0-5.812 3.212 6 6 0 0 0-.331.021"
      />
      <path
        fill={`url(#${_id4})`}
        d="m2.206 16.804 11.198-4.7-7.547-3.87C3.13 8.491 1 10.741 1 13.478c0 1.26.452 2.418 1.206 3.325"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={4.043}
          x2={19.721}
          y1={17.833}
          y2={16.877}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2086B8" />
          <stop offset={1} stopColor="#46D3F6" />
        </linearGradient>
        <linearGradient
          id={_id2}
          x1={17.383}
          x2={21.77}
          y1={14.396}
          y2={11.331}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1694DB" />
          <stop offset={1} stopColor="#62C3FE" />
        </linearGradient>
        <linearGradient
          id={_id3}
          x1={6.852}
          x2={17.043}
          y1={5.917}
          y2={11.83}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3D78" />
          <stop offset={1} stopColor="#063B83" />
        </linearGradient>
        <linearGradient
          id={_id4}
          x1={0.766}
          x2={11.012}
          y1={14.625}
          y2={10.82}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#16589B" />
          <stop offset={1} stopColor="#1464B7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(MsOneDriveBright);
export { ForwardRef as MsOneDriveBright };
